import { lazy } from 'react';

export const Rewards = lazy(() => import('./Rewards.component'));
export const Info = lazy(() => import('./components/Info'));
